export const templatesSelectors = {
  isFetching: state => state.templates.isFetching,
  isPending: state => state.templates.isPending,
};
